import React from 'react';
import './Style/PrivacyPolicy.css';
import TopNavbar from './../home/TopNavbar';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <TopNavbar name="Privacy Policy" />
      <div className="privacy-card">
        <h1 className="privacy-title">Privacy Policy</h1>
        <p className="privacy-updated">Last Updated: September 2026</p>

        <section className="privacy-section">
          <h2>1. Introduction</h2>
          <p>
            Welcome to JEE Mock Test. We value your privacy and are committed to providing a completely free, ad-free, and secure environment for your Joint Entrance Examination preparation (JEE Main and JEE Advanced). This Privacy Policy explains how we handle information within our mobile application.
          </p>
        </section>

        <section className="privacy-section">
          <h2>2. No Personal Data Collection</h2>
          <p>
            Our app is built with a "Privacy-First" approach. We do not collect, store, transmit, or share any Personally Identifiable Information (PII).
          </p>
          <ul>
            <li>No Name, Email, or Phone Number is required to use the app.</li>
            <li>No Account creation (Login/Signup) is needed.</li>
            <li>No access to your contacts, location, media, or sensitive phone files.</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>3. Local Storage of Test Data</h2>
          <p>
            All your mock test data, including scores, subject-wise percentages (Physics, Chemistry, and Mathematics), and progress reports, are stored exclusively on your device's Local Storage.
          </p>
          <p>
            We do not maintain a central database or external server to record your test activities. Your practice data remains strictly on your phone and can be cleared at any time by clearing the app cache or uninstalling the app.
          </p>
        </section>

        <section className="privacy-section">
          <h2>4. No Ads & No Third-Party Analytics</h2>
          <p>
            Our app is 100% free for all students. We do not display any third-party advertisements (such as Google AdMob), nor do we integrate third-party tracking or profiling analytics SDKs.
          </p>
        </section>

        <section className="privacy-section">
          <h2>5. Government Entity & Official Exam Disclaimer</h2>
          <p>
            JEE Mock Test is an independent educational platform and is not affiliated with, endorsed by, or connected to National Testing Agency (NTA), IITs, or any official government examination authority.
          </p>
        </section>

        <section className="privacy-section">
          <h2>6. Target Audience</h2>
          <p>
            Our app is intended for engineering aspirants preparing for JEE Main and Advanced examinations. Since we do not collect any personal information, we do not knowingly collect data from children under the age of 13.
          </p>
        </section>

        <section className="privacy-section">
          <h2>7. Changes to This Policy</h2>
          <p>
            We may update our Privacy Policy from time to time. We will notify you of any changes by updating the "Last Updated" date at the top of this page.
          </p>
        </section>

        <section className="privacy-section contact-section">
          <h2>8. Contact Us</h2>
          <p>If you have any questions about this Privacy Policy, please contact us at:</p>
          <div className="contact-details">
            <p><strong>Email:</strong> <a href="mailto:contact@mystudyplace.in">contact@mystudyplace.in</a></p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;